import TopBanner from "@/components/banner/TopBanner";
import { useFailure } from "@/hooks/useFailure";
import { nestInitialize, validateSession } from "@/lib/nest";
import { getAccessCode, GetSafeRedirectUrl, setSearchParamsToCookies } from "@/lib/utils";
import LoginPage from "@/pages/Login";
import { CookieContext, createCookieStore } from "@/stores/CookieStore";
import { ErrorCodeType } from "@/types";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

type SearchParams = {
  errorCode?: ErrorCodeType;
  usetpa?: string | number;
  signup?: number;
  accesscode?: number;
  redirect?: string;
  type?: string;
  sec?: string;
  state?: string; // fallback 시 전달되는 값
};

export const Route = createFileRoute("/login/")({
  component: Index,
  validateSearch: (search) => search as SearchParams,
  loaderDeps: ({ search: { errorCode, usetpa, signup, state } }) => ({ errorCode, usetpa, signup, state }),
  beforeLoad: async () => {
    await nestInitialize();

    const isValid = await validateSession();
    if (isValid) {
      document.location.href = GetSafeRedirectUrl();
      return;
    }
  },
  loader: ({ deps: { errorCode, usetpa, signup, state } }) => {
    return { ...setSearchParamsToCookies(errorCode, usetpa, signup), errorCode, state };
  },
});

function Index() {
  const { usetpa, signup, errorCode, state } = Route.useLoaderData();
  const store = useRef(createCookieStore({ usetpa, signup })).current;

  const { handleRedirectFailure } = useFailure();

  useEffect(() => {
    if (!errorCode || !state) {
      return;
    }

    handleRedirectFailure({ code: errorCode, appendix: { state } }, { accesscode: getAccessCode() });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CookieContext.Provider value={store}>
      <TopBanner />
      <LoginPage />
    </CookieContext.Provider>
  );
}
